"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = require("styled-components");
var _constants = require("../../../../constants");
const ChevronPrizm = props => _react.default.createElement("svg", (0, _extends2.default)({
  width: "16px",
  height: "16px",
  viewBox: "0 0 16 16"
}, props), _react.default.createElement("defs", null, _react.default.createElement("filter", {
  id: "filter-1"
}, _react.default.createElement("feColorMatrix", {
  in: "SourceGraphic",
  type: "matrix",
  values: "0 0 0 0 0.644000 0 0 0 0 0.670133 0 0 0 0 0.700000 0 0 0 1.000000 0"
}))), _react.default.createElement("g", {
  stroke: "none",
  strokeWidth: "1",
  fillRule: "evenodd"
}, _react.default.createElement("g", {
  filter: "url(#filter-1)"
}, _react.default.createElement("g", {
  transform: "translate(5.000000, 3.000000)"
}, _react.default.createElement("path", {
  d: "M5.70710678,5.70710678 L1.70710678,9.70710678 C1.31658249,10.0976311 0.683417511,10.0976311 0.292893219,9.70710678 C-0.0976310729,9.31658249 -0.0976310729,8.68341751 0.292893219,8.29289322 L3.58540421,5.00038223 L0.292893219,1.70710678 C-0.0976310729,1.31658249 -0.0976310729,0.683417511 0.292893219,0.292893219 C0.683417511,-0.0976310729 1.31658249,-0.0976310729 1.70710678,0.292893219 L5.70710678,4.29289322 C6.09763107,4.68341751 6.09763107,5.31658249 5.70710678,5.70710678 Z"
})))));
const ChevronMDS = props => _react.default.createElement("svg", (0, _extends2.default)({
  width: "24px",
  height: "24px",
  viewBox: "0 0 24 24"
}, props), _react.default.createElement("g", {
  stroke: "none",
  strokeWidth: "1",
  fillRule: "evenodd"
}, _react.default.createElement("polygon", {
  points: "9.25 15.7071068 9.95710678 16.4142136 14.6642136 11.7071068 9.95710678 7 9.25 7.70710678 13.25 11.7071068"
})));
const AbstractChevron = ({
  theme,
  ...other
}) => theme.name === _constants.THEMES.mds ? _react.default.createElement(ChevronMDS, other) : _react.default.createElement(ChevronPrizm, other);
var _default = exports.default = (0, _styledComponents.withTheme)(AbstractChevron);